import {createSelector} from "reselect";
import {getAdminStoreState} from "../../store/admin-store-selectors";

export const getOrganizationsState = createSelector(getAdminStoreState, state => state.organizations);
